import React from 'react';

export function Loader_sidebar(){
    return (<div className="spinner_sideleft">
    <div className="bounce1"></div>
    <div className="bounce2"></div>
    <div className="bounce3"></div>
  </div>);
}